import React, { useState, createContext, useContext } from "react";

const SidebarContext = createContext({});

export const useSidebarContext = () => useContext(SidebarContext);

export const MyProSidebarProvider = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <SidebarContext.Provider value={{ collapsed, setCollapsed }}>
      {children}
    </SidebarContext.Provider>
  );
};
